import React from "react";

import { useTranslation } from "react-i18next";

import { WrappedNavLink } from "@components/navigation";
import { useRootAppStore } from "@hooks";
import { THEME_SETTINGS } from "@theme-settings";
import { getCurrentCulture } from "@utils";
import { observer } from "mobx-react";

export const ActivateWalletButton = observer(
	function ActivateWalletButton(props: {
		setIsNavMenuOpen: (value: boolean) => void;
	}) {
		const { t } = useTranslation(["translation", "wallet-grace-period"]);
		const rootStore = useRootAppStore();

		if (
			THEME_SETTINGS.isDKMW ||
			!rootStore.userAuthStore.shouldDisplayActivateWallet
		) {
			return null;
		}

		return (
			<WrappedNavLink
				className="btn btn--med btn--block btn--icon btn--accent"
				to={`/${getCurrentCulture()}/auth/activate-wallet`}
				onClick={() => {
					props.setIsNavMenuOpen(false);
				}}
			>
				<span>{t("wallet-grace-period:ACTIVATE_WALLET_TITLE")}</span>
			</WrappedNavLink>
		);
	}
);
